import React, {Component} from "react";

import axios from 'axios';
import Constants from '../../../components/Constants/';
import AuthActions from '../../../actions/AuthActions';
import AuthStore from '../../../stores/AuthStore';
import history from '../../../history';
import {
    Row,
    Col,
    Button,
    Label,
    Input,
    InputGroup,
    InputGroupButton,
    Link,
    Table,
    Badge

} from "reactstrap";

import AlertContainer from 'react-alert';

class MyAccount extends Component {

  constructor(props) {
    super(props);
    this.updateInputValue = this.updateInputValue.bind(this);
    this.updatePasswordConfValue = this.updatePasswordConfValue.bind(this);
    this.save = this.save.bind(this);
    this.showAlert = this.showAlert.bind(this);

    this.state = {
        user: {
          userName: AuthStore.getState().user.username,
          password: ""
        },
        passwordConf: ""
      };

      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }

    }

    updateInputValue(evt, input) {
      let actualUser = this.state.user;
      actualUser[input] = evt.target.value;

      this.setState({
        user: actualUser
      });
    }

    updatePasswordConfValue(evt, input) {
      this.setState({
        passwordConf: evt.target.value
      });
    }

    showAlert(message){
      this.msg.show(message, {
        time: 10000,
        type: 'error'
      });
    }

    save(){
      if(this.state.passwordConf != this.state.user.password){
        this.showAlert("As senhas digitadas são diferentes.");
      }else{
        axios({
            method: 'post',
            url: Constants.apiUrl+'/api/v1/user/changepass',
            data: this.state.user
        })
        .then(response => {
            history.replace("dashboard");
        });
      }
    }

    render() {
      if(this.state.user == null) return null

      return(
          <div>
            <h2>{AuthStore.getState().user.entity_name}</h2>
            <hr />

            <Row>
              <Col xs="12" md="6">

                <Label>Username:</Label>
                <Input type="text" id="username" ref="username" value={AuthStore.getState().user.username} readonly={true} />
              </Col>
            </Row>
            <Row>
              <Col xs="12" md="6">
                <Label>Nova Senha:</Label>
                <Input type="password" id="password" ref="password" value={this.state.user.password}
                    onChange={evt => this.updateInputValue(evt, "password")} placeholder="Senha"/>
              </Col>
            </Row>
            <Row>
              <Col xs="12" md="6">
                <Label>Confirme a Senha:</Label>
                <Input type="password" id="passwordConf" ref="passwordConf" value={this.state.passwordConf}
                    onChange={evt => this.updatePasswordConfValue(evt, "passwordConf")} placeholder="Confirme sua Senha"/>
              </Col>
            </Row>
            <br />
            <Button color="success" onClick={() => { this.save(); }}>Salvar</Button>

            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default MyAccount;



// WEBPACK FOOTER //
// ./src/views/Components/MyAccount/MyAccount.js